import api from 'service/api'
import { to } from 'nh-utils'
import { origin_device } from 'utils/deviceDetector'

export const sendForm = form => {
  const payload = { ...form, origin_device }
  return to(api.post(`/v2/contact`, payload))
}
